// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24Q9v","largestCol":"styles_largestCol__3egnq","smallestCol":"styles_smallestCol__BZ2GN"};